const pagesMarketplaceEn = {
  registerNewPlace: "Save the address to reuse as place",
  newPlaceName: "Place name",
  newPlaceNamePlaceholder: "Type place name...",
  marketplace: "Marketplace",
  deviceMarket: "Device Market",
  store: "Store",
  orders: "Orders",
  marketplaceUnavailable: "Marketplace Unavailable",
  marketplaceUnavailableDescription:
    "Sorry, but the marketplace is currently unavailable. Please contact the administrator.",
  productNotFound: "Product not found",
  variantNotFound: "Product variant not found",
  quotation: "Quotation",
  oneshot: "Initial",
  recurring: "Recurring",
  payment: "Payment",
  quantity: "Quantity",
  quotationRequired: "Quotation required",
  initialPayment: "Initial",
  recurringPayment: "Recurring",
  validationError: "Validation Error",
  pleaseSelectAllRequiredOptions: "Please select all required options",
  searchByFreeTextPlaceholder: "Search by free text",
  contractType: "Contract Type",
  deviceType: "Device Type",
  priceRange: "Price Range",
  rental: "Rental",
  purchase: "Purchase",
  itemList: "Item List",
  itemDetail: "Item Detail",
  cart: "Cart",
  addToCart: "Add to cart",
  addingToCart: "Adding...",
  all: "All",
  requestSent: "Request sent",
  approved: "Approved",
  canceled: "Canceled",
  itemsInCart: "Items in cart",
  handoverNotes: "Handover notes",
  handoverNotesForVendor: "Notes to vendor (Optional)",
  handoverNotesPlaceholder: "Anything you need to tell to the vendor.",
  subtotal: "Subtotal",
  initial: "Initial",
  successfullyRemovedFromCart: "Successfully removed from cart",
  quantityUpdated: "Quantity updated",
  confirmOrderSuccess: "Order confirmed",
  emptyCart: "Cart is empty",
  emptyCartDescription: "Add items to your cart to get started",
  total: "Total",
  selectPlaceOrEnterAddress:
    "Select place or manually enter a valid address form",
  lineNumber: "Line Number",
  description: "Description",
  unitPrice: "Unit Price",
  totalPrice: "Total Price",
  period: "Period",
  taxPerUnit: "Tax per Unit",
  details: "Details",
  tax: "Tax",
  amountToPay: "Amount to pay",
  delivery: "Delivery",
  estimatedDate: "Estimated date",
  requestDate: "Request date",
  agreementDate: "Agreement date",
  cancellationDate: "Cancellation date",
  orderer: "Orderer",
  shipping: "Shipping",
  address: "Address",
  place: "Place",
  status: "Status",
  vendor: "Vendor",
  searchOrdersPlaceholder: "Filter orders...",
  selectPlacePlaceholder: "Select a place...",
  placeOrder: "Place order",
  backToPlaceSelection: "Back to Place Selection",
  addShippingAddressManually: "Add Shipping Address Manually",
  addedToCartDialog: {
    addedToCart: "Added To Cart!",
    goToCart: "Go to Cart",
    backToStore: "Back to Store",
  },
  customer: "Customer",
  searchCustomerPlaceholder: "Search Customer...",
  markAsReceived: "Mark as Received",
  markAsReceivedDescription:
    "Mark the all product of this order as received.\nThis action cannot be undone.",
  markAsReceivedOkButton: "Execute",
  confirmed: "Confirmed",
};

export default pagesMarketplaceEn;
